
import React from 'react';
import { Container, Grid } from '@mui/material';
import PrimaryContent from '../../Utilities/PrimaryContent';
import PrimaryHeading from '../../Utilities/PrimaryHeading';

export default function WhatIsNCPro() {
  return (
    <Container maxWidth="xl"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '600px',
        paddingTop: '15px',
        paddingBottom: '15px',
      }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <img
            src="/images/what-is-ncpro-image.svg"
            alt="NC Pro"
          />
        </Grid>
        <Grid item xs={12} md={7} sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <PrimaryHeading sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-end' },
          }}>
            What is <span style={{
              color: 'white',
              background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
              opacity: '90%',
              marginLeft:'5px',
            }}>NC Pro?</span>
          </PrimaryHeading>
          <PrimaryContent sx={{ textAlign: { xs: 'center', md: 'left' }, pt: 3, pb: 2 }}>
            It is more than just a non-conformity reporting tool – it’s your strategic partner in driving continuous improvement and compliance.
          </PrimaryContent>
          <ul style={{ listStyleType: 'none', margin: '8px' }}>
            <li style={{
              position: 'relative',
              paddingLeft: '20px',
              paddingBottom: '18px',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '24px',
              textAlign: 'left',
              letterSpacing: '0.02em',
              color: 'rgba(84, 84, 84, 1)',
              textUnderlinePosition: 'from-font',
              textDecorationSkipInk: 'none',
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                top: '18%',
                transform: 'translateY(-50%)',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#000000',
                opacity: '60%'
              }} />
              Built around the powerful <span style={{ color: 'rgba(5, 162, 219, 1)', fontStyle: 'italic' }}>8D (Eight Disciplines) Model</span>, NC pro guides you through every step of the quality issue resolution process, ensuring that problems are not only identified but systematically addressed and prevented in the future.
            </li>
            <li style={{
              position: 'relative',
              paddingLeft: '20px',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '24px',
              textAlign: 'left',
              letterSpacing: '0.02em',
              color: 'rgba(84, 84, 84, 1)',
              textUnderlinePosition: 'from-font',
              textDecorationSkipInk: 'none',
            }}>
              <span style={{
                position: 'absolute',
                left: 0,
                top: '18%',
                transform: 'translateY(-50%)',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: '#000000',
                opacity: '60%'
              }} />
              Our software integrates the <span style={{ color: 'rgba(5, 162, 219, 1)', fontStyle: 'italic' }}>3RC method</span> Process Root Cause (PRC), Non-Detected Root Cause (NDRC) (NDRC), and System Root Cause (SRC)—to ensure a thorough investigation of every non-conformity, helping you uncover hidden risks and improve your processes from the ground up.
            </li>
          </ul>
        </Grid>
      </Grid>
    </Container>
  )
}